import React from 'react'
import {Icon} from '@chakra-ui/react'

const WarningIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" data-testid="warning-icon" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.8741 20.5144L12.8741 2.51436C12.4931 1.82855 11.5068 1.82855 11.1258 2.51436L1.12582 20.5144C0.755521 21.1809 1.23749 22 1.99997 22H22C22.7625 22 23.2444 21.1809 22.8741 20.5144ZM3.69949 20L12 5.05913L20.3005 20H3.69949ZM11 9H13V15H11V9ZM13 18V16H11V18H13Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default WarningIcon
